import type { createRouter } from '@tanstack/react-router';
import { createAuthRoutes } from '#features/auth';
import { createBookmarksRoutes } from '#features/bookmarks';
import { createDashboardsRoutes } from '#features/dashboards';
import { createHomeRoutes } from '#features/home';
import { createNotebooksRoutes } from '#features/notebooks';
import { createSearchRoutes } from '#features/search/v2';
import { createSettingsRoutes } from '#features/settings';
import { createTaskListsRoutes } from '#features/task-lists';
import { appRoute, rootRoute } from './routes';

export const createRouteTree = () => {
  const authRoutes = createAuthRoutes(rootRoute);
  const homeRoutes = createHomeRoutes(appRoute);
  const searchRoutes = createSearchRoutes(appRoute);
  const dashboardsRoutes = createDashboardsRoutes(appRoute);
  const settingsRoutes = createSettingsRoutes(appRoute);
  const bookmarksRoutes = createBookmarksRoutes(appRoute);
  const notebooksRoute = createNotebooksRoutes(appRoute);
  const taskListsRoute = createTaskListsRoutes(appRoute);

  return rootRoute.addChildren([
    ...authRoutes,
    appRoute.addChildren([
      ...homeRoutes,
      ...notebooksRoute,
      ...taskListsRoute,
      ...searchRoutes,
      ...dashboardsRoutes,
      ...settingsRoutes,
      ...bookmarksRoutes
    ])
  ]);
};

type Router = ReturnType<
  typeof createRouter<ReturnType<typeof createRouteTree>>
>;

declare module '@tanstack/react-router' {
  // biome-ignore lint/style/useConsistentTypeDefinitions: ignore
  interface Register {
    router: Router;
  }
}
